export const firebaseConfig = {
  apiKey: "AIzaSyArnCSkwSEfENfv6yPdL6DPDE84Xn7Kda4",
  authDomain: "hann-hwa-fabrics.firebaseapp.com",
  projectId: "hann-hwa-fabrics",
  storageBucket: "hann-hwa-fabrics.appspot.com",
  messagingSenderId: "4532558450",
  appId: "1:4532558450:web:44ae4fe020c77c2af840eb",
  measurementId: "G-C3NHFRTD1N"
};
